import { Component, OnInit } from '@angular/core';
import { JudgmentsOrdersService } from '../../core/services/judgments-orders.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-judgments-orders',
  templateUrl: './judgments-orders.component.html',
  styleUrls: ['./judgments-orders.component.scss'],
})
export class JudgmentsOrdersComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Judgments and Orders',
    },
  ];

  data: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 24;
  years: number[] = [];
  selectedYear: number | null = null;
  selectedMonth: number | null = null;

  months = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' },
  ];

  constructor(
    private judgmentsOrdersService: JudgmentsOrdersService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    // Get year and month from URL query params
    this.route.queryParams.subscribe((params) => {
      if (params['year']) {
        this.selectedYear = Number(params['year']);
      }
      if (params['month']) {
        this.selectedMonth = Number(params['month']);
      }
    });

    this.loadYears();
    this.loadData();
  }

  loadYears(): void {
    this.judgmentsOrdersService.getYears().then((years) => {
      this.years = years;
    });
  }

  loadData(): void {
    this.judgmentsOrdersService
      .getJudgmentsOrders(
        this.selectedYear || undefined,
        this.selectedMonth || undefined,
        this.currentPage,
        this.pageSize,
      )
      .then((response: any) => {
        this.data = response.docs || [];
        this.totalDocs = response.totalDocs || 0;
      });
  }

  filterData(): void {
    this.currentPage = 1;
    this.loadData();
  }

  clearFilter(): void {
    this.selectedYear = null;
    this.selectedMonth = null;
    this.currentPage = 1;
    this.loadData();
  }

  onCurrentPageDataChange(page: number): void {
    this.currentPage = page;
    this.loadData();
  }

  getFileUrl(file: any): string {
    if (file && file.url) {
      return file.url;
    }
    if (file && typeof file === 'string') {
      return file;
    }
    return '#';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return this.datePipe.transform(date, 'dd MMM yyyy') || '';
  }
}




